import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { MiscApi, RequestStrategyEnum, type WithSignal } from '@shared/api';

const getAvailableCurrenciesEffect = createEffect(({ signal }: WithSignal = {}) => MiscApi.getAvailableCurrencies(signal));
const clearEvent = createEvent();

const $dataStore = createStore<string[]>([])
  .on(getAvailableCurrenciesEffect.done, (current, data) => data.result.data ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(true)
  .on(getAvailableCurrenciesEffect.pending, (_, data) => data)
  .on(getAvailableCurrenciesEffect.fail, () => false)
  .on(getAvailableCurrenciesEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getAvailableCurrenciesEffect, () => null)
  // .on(getAvailableCurrenciesEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getAvailableCurrenciesEffect.fail, () => 'Something went wrong while fetching Available Currencies. Please try again.')
  .on(getAvailableCurrenciesEffect.done, () => null)
  .reset(clearEvent);

export const $initialCurrenciesAvailableStore = {
  events: {
    getAvailableCurrencies: ApiUtils.wrapperApi(getAvailableCurrenciesEffect, RequestStrategyEnum.Debounce).trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
